import { SiteActivityType } from 'module/patient/activity/types/types';

export const siteActivityPath = `/chart/:patientId/activity/${SiteActivityType.SITE}/:studyPk/:activitySk/:eventSk/:activityInstanceId?`;

export const homeActivityPath = `/chart/:patientId/activity/${SiteActivityType.HOME}/:studyPk/:activitySk/:activityInstanceId?/:episodic`;

export const dcrActivityPath = `/chart/:patientId/activity/${SiteActivityType.DCR}/:studyPk/:activitySk/:activityInstanceId?/:episodic`;
